import React from 'react';
import { connectLean } from 'lean-redux';
import { store } from 'legacy-src/store';

const internals = {
  data: [],
  index: 1,
};

const createAnnotation = (variables, onCompleted, setAnnotationData) => () => {
  const { data } = internals;
  data.push({ id: internals.index, ...variables });
  internals.index++;
  setAnnotationData(data);
  onCompleted();
};
const updateAnnotation = (variables, onCompleted, setAnnotationData) => () => {
  const { data } = internals;
  const index = data.findIndex(
    (x) => x.id === variables.learnosityAnnotationId,
  );
  data[index].annotation = variables.annotation;
  setAnnotationData(data);
  onCompleted();
};
const deleteAnnotation = (variables, onCompleted, setAnnotationData) => () => {
  const { data } = internals;
  const index = data.findIndex(
    (x) => x.id === variables.learnosityAnnotationId,
  );
  data.splice(index, 1);
  setAnnotationData(data);
  onCompleted();
};

const dataPersistence = connectLean({
  getInitialState() {
    return { annotationData: [], loading: false };
  },
  setAnnotationData(annotationData) {
    this.setState({ annotationData });
  },
});

const withStore = (Wrapped) => (props) => <Wrapped {...props} store={store} />;

export default {
  modal: withStore(
    dataPersistence(
      ({ children, variables, loading, onCompleted, setAnnotationData }) =>
        children({
          createAnnotationRequest: {
            loading,
            createAnnotation: createAnnotation(
              variables,
              onCompleted,
              setAnnotationData,
            ),
          },
          updateAnnotationRequest: {
            loading,
            updateAnnotation: updateAnnotation(
              variables,
              onCompleted,
              setAnnotationData,
            ),
          },
          deleteAnnotationRequest: {
            loading,
            deleteAnnotation: deleteAnnotation(
              variables,
              onCompleted,
              setAnnotationData,
            ),
          },
        }),
    ),
  ),
  main: withStore(
    dataPersistence(({ children, loading, annotationData }) =>
      children({
        annotationDataRequest: {
          loading,
          data: { learnosityAssignmentAnnotations: annotationData },
        },
      }),
    ),
  ),
};
